import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import getBreakpointView from 'utils/getBreakpointView';
import { socialData } from './static/socialData';

import { Container } from './styles';

const AddThisSocialSharing = ({ placement, shareText }) => {
  const [pagePath, setPagePath] = useState(null);
  const [pageTitle, setPageTitle] = useState(null);

  useEffect(() => {
    if (placement) {
      if (window) {
        setPagePath(window.location.pathname);
      }
      if (window.addthis) {
        window.addthis.toolbox('.addthis_toolbox');
      }
      if (document) {
        setPageTitle(document.title);
      }
    }
  });

  const handleClick = platform => {
    if (typeof window !== 'undefined') {
      dataLayer.push({
        event: 'social interaction',
        social_action: 'share',
        social_network: platform,
        page_path: window.location.href,
      });
    }
  };

  const script = (
    <Helmet>
      <script
        type="text/javascript"
        src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5e1f60abab3d83b5"
      />
    </Helmet>
  );

  if (placement) {
    return (
      <Container
        className={`addthis_toolbox ${placement}`}
        placement={placement}
        data-addthis-url={`http://www.servicetitan.com${pagePath}`}
        data-addthis-title={shareText || pageTitle}
      >
        {socialData.map(platform => {
          return (
            <a className={platform.class} onClick={() => handleClick(platform.platform)}>
              <img
                src={placement === 'quote' ? platform.iconBlue : platform.icon}
                width="64"
                height="64"
                border="0"
                alt={platform.alt}
              />
            </a>
          );
        })}
        {script}
      </Container>
    );
  } else {
    return script;
  }
};

export default AddThisSocialSharing;
